import { ApplicationInstanceServiceData, CrashEventServiceData } from 'services/GameHosting/ApplicationInstances/applicationInstanceServiceType';
import { TaskStatusServiceData } from 'types/common/odp';
import { ApplicationInstanceStatus } from 'types/GameHosting/instance';
import { FetchAction, ResetReducerAction } from 'types/services/redux-action';
import { FetchReducer } from 'types/services/redux-state';

export const FETCH_APPLICATION_INSTANCES = 'FETCH_APPLICATION_INSTANCES';

export const FETCH_APPLICATION_INSTANCES_IS_PENDING = 'FETCH_APPLICATION_INSTANCES_IS_PENDING';

export const FETCH_APPLICATION_INSTANCES_IS_ERROR = 'FETCH_APPLICATION_INSTANCES_IS_ERROR';

export const FETCH_APPLICATION_INSTANCES_STATUS = 'FETCH_APPLICATION_INSTANCES_STATUS';

export const FETCH_APPLICATION_INSTANCES_STATUS_IS_PENDING = 'FETCH_APPLICATION_INSTANCES_STATUS_IS_PENDING';

export const FETCH_APPLICATION_INSTANCES_STATUS_IS_ERROR = 'FETCH_APPLICATION_INSTANCES_STATUS_IS_ERROR';

export const FETCH_APPLICATION_INSTANCE_BY_ID = 'FETCH_APPLICATION_INSTANCE_BY_ID';

export const FETCH_APPLICATION_INSTANCE_BY_ID_IS_PENDING = 'FETCH_APPLICATION_INSTANCE_BY_ID_IS_PENDING';

export const FETCH_APPLICATION_INSTANCE_BY_ID_IS_ERROR = 'FETCH_APPLICATION_INSTANCE_BY_ID_IS_ERROR';

export const FETCH_APPLICATION_INSTANCE_BY_HOSTID = 'FETCH_APPLICATION_INSTANCE_BY_HOSTID';

export const FETCH_APPLICATION_INSTANCE_BY_HOSTID_IS_PENDING = 'FETCH_APPLICATION_INSTANCE_BY_HOSTID_IS_PENDING';

export const FETCH_APPLICATION_INSTANCE_BY_HOSTID_IS_ERROR = 'FETCH_APPLICATION_INSTANCE_BY_HOSTID_IS_ERROR';

export const FETCH_APPLICATION_INSTANCE_TASKS = 'FETCH_APPLICATION_INSTANCE_TASKS';

export const FETCH_APPLICATION_INSTANCE_TASKS_IS_PENDING = 'FETCH_APPLICATION_INSTANCE_TASKS_IS_PENDING';

export const FETCH_APPLICATION_INSTANCE_TASKS_IS_ERROR = 'FETCH_APPLICATION_INSTANCE_TASKS_IS_ERROR';

export const FETCH_APPLICATION_INSTANCE_CRASHES = 'FETCH_APPLICATION_INSTANCE_CRASHES';

export const FETCH_APPLICATION_INSTANCE_CRASHES_IS_PENDING = 'FETCH_APPLICATION_INSTANCE_CRASHES_IS_PENDING';

export const FETCH_APPLICATION_INSTANCE_CRASHES_IS_ERROR = 'FETCH_APPLICATION_INSTANCE_CRASHES_IS_ERROR';

export const START_INSTANCE = 'START_INSTANCE';

export const START_INSTANCE_IS_PENDING = 'START_INSTANCE_IS_PENDING';

export const START_INSTANCE_IS_ERROR = 'START_INSTANCE_IS_ERROR';

export const STOP_INSTANCE = 'STOP_INSTANCE';

export const STOP_INSTANCE_IS_PENDING = 'STOP_INSTANCE_IS_PENDING';

export const STOP_INSTANCE_IS_ERROR = 'STOP_INSTANCE_IS_ERROR';

export const RESTART_INSTANCE = 'RESTART_INSTANCE';

export const RESTART_INSTANCE_IS_PENDING = 'RESTART_INSTANCE_IS_PENDING';

export const RESTART_INSTANCE_IS_ERROR = 'RESTART_INSTANCE_IS_ERROR';

export type ApplicationInstanceReducerState = {
  applicationInstances: ApplicationInstanceServiceData[];
  applicationInstancesByHostId: ApplicationInstanceServiceData | undefined;
  status: ApplicationInstanceStatus[];
  applicationInstance: ApplicationInstanceServiceData | undefined;
  tasks: TaskStatusServiceData[];
  crashes: CrashEventServiceData[];
} & FetchReducer<
  'fetch' | 'fetchByHostId' | 'fetchById' | 'fetchStatus' | 'fetchTasks' | 'fetchCrashes' | 'startInstanceId' | 'stopInstanceId' | 'restartInstanceId'
>;

export type ApplicationInstanceActions =
  | FetchAction<'FETCH_APPLICATION_INSTANCES', ApplicationInstanceServiceData[]>
  | FetchAction<'FETCH_APPLICATION_INSTANCE_BY_ID', ApplicationInstanceServiceData>
  | FetchAction<'FETCH_APPLICATION_INSTANCE_BY_HOSTID', ApplicationInstanceServiceData>
  | FetchAction<'FETCH_APPLICATION_INSTANCES_STATUS', ApplicationInstanceStatus[]>
  | FetchAction<'FETCH_APPLICATION_INSTANCE_CRASHES', CrashEventServiceData[]>
  | FetchAction<'FETCH_APPLICATION_INSTANCE_TASKS', TaskStatusServiceData[]>
  | FetchAction<'START_INSTANCE' | 'STOP_INSTANCE' | 'RESTART_INSTANCE', TaskStatusServiceData>
  | { type: 'RESET_APPLICATION_INSTANCES_REDUCER' }
  | ResetReducerAction;
